import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJcsStorageManagementRoute: InvariantJiraRoute = {
	name: 'products-jcs-storage-management',
	path: '/jira/settings/products/customerservice/storage-management',
	exact: true,
};
